import React from 'react';
import AnalyticsService from '../../../../../../services/AnalyticsService';
import { MinPriceBtn } from './styles';

export default class MinPriceUrl extends React.Component {

  handleClick = (event) => {
    AnalyticsService.sendClick('min-price', this.props.phoneNumber, this.props.priceDiff);
  }

  render = () => <MinPriceBtn onClick={this.handleClick} href={this.props.url} target="_blank">Legolcsóbb hirdetés</MinPriceBtn>;

}



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/components/MinPriceUrl/index.js